'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (duration, unit) {
    switch (unit) {
        case 't':
        case 's':
            return duration;
        case 'm':
            return 60 * duration;
        case 'h':
            return 3600 * duration;
        case 'd':
            return 86400 * duration;
        default:
            throw new Error('Duration unit not valid: ' + unit + ', only allow [\'t\', \'s\', \'m\', \'h\', \'d\']');
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/binary-utils/lib/duration/durationToSecs.js
// module id = 165
// module chunks = 0